const transformBusinessHoursToFields = (businessHours) => {
    const data = {};
    businessHours.forEach(({ week_day, open, open_time, close_time }) => {
        data[`businessHours_${week_day}_open`] = open;
        data[`businessHours_${week_day}_open_time`] = open_time;
        data[`businessHours_${week_day}_close_time`] = close_time;
    });
    return data;
};

const locationParser = (response, type, resource, params) => {

    if (type === 'GET_ONE' && resource === 'locations') {
        const respData = response.json;

        if (respData.businessHours) {
            const businessHoursFields = transformBusinessHoursToFields(respData.businessHours);
            response.json = { ...respData, ...businessHoursFields };
        }
        if (respData.storePhoto) {
            window._storePhoto = respData.storePhoto;
        }

        return response;
    } else {
        return response;
    }

}

export default locationParser;